import * as yup from 'yup';
import { Report } from 'types/report';
import { calculateLost } from 'utils/calculateLost';

export const getInitialValues = (report: Report | null | undefined) => ({
  customerSiteName: report?.site?._id || '',
  id: report?._id || '',
  name: report?.name || '',
  startDate: report?.startDate || '',
  endDate: report?.endDate || '',
  month: report?.month || '',
  year: report?.year || '',
  single_use_items: report?.details
    ? report?.details?.reduce(
        (acc, item) => acc + item.ret + calculateLost(item),
        0,
      )
    : 0,
  wd: '0',
  co2m: '0',
  wc: '0',
  er: '0',
  cos: '0',
  site: '',
});

export const validationSchema = yup.object().shape({
  id: yup.string().required('Select Inventory Report'),
  name: yup.string().required('Name is required'),
  startDate: yup.string().required('Start Date is required'),
  endDate: yup.string().required('End Date is required'),
  month: yup.string().required('Please select a month'),
  year: yup.string().required('Please select a year'),
  wd: yup
    .string()
    .required('Required')
    .test('is-valid-number', 'Must be a valid number', (value) => {
      if (!value) return false;
      const valueWithoutCommas = value.replace(/,/g, ''); // Remove commas
      return !isNaN(Number(valueWithoutCommas));
    }),
  co2m: yup
    .string()
    .required('Required')
    .test('is-valid-number', 'Must be a valid number', (value) => {
      if (!value) return false;
      const valueWithoutCommas = value.replace(/,/g, ''); // Remove commas
      return !isNaN(Number(valueWithoutCommas));
    }),
  wc: yup
    .string()
    .required('Required')
    .test('is-valid-number', 'Must be a valid number', (value) => {
      if (!value) return false;
      const valueWithoutCommas = value.replace(/,/g, ''); // Remove commas
      return !isNaN(Number(valueWithoutCommas));
    }),
  er: yup
    .string()
    .required('Required')
    .test('is-valid-number', 'Must be a valid number', (value) => {
      if (!value) return false;
      const valueWithoutCommas = value.replace(/,/g, ''); // Remove commas
      return !isNaN(Number(valueWithoutCommas));
    }),
  cos: yup
    .string()
    .required('Required')
    .test('is-valid-number', 'Must be a valid number', (value) => {
      if (!value) return false;
      const valueWithoutCommas = value.replace(/,/g, ''); // Remove commas
      return !isNaN(Number(valueWithoutCommas));
    }),
});
